<template>
  <div class="put_import_container" :class="{ 'full_page': send }">
    <template v-show="!send">
      <div class="p_i_left">
        <ImportCondition
          v-if="isImport"
          :config="apiObj"
          @search="importSearch"
          @progress="uploadProgress"
          :importStatus.sync="importStatus">
        </ImportCondition>
        <ReputOrderCondition v-else-if="isOrderReput" @search="searchWifiByOrder"></ReputOrderCondition>
        <OrderFormPoint v-else @submit="conditionSearch"></OrderFormPoint>
      </div>
      <div class="p_i_right" v-show="!send">
        <div class="p_i_import" v-if="isImport && importStatus === 0">
          <img src="../../assets/import_guid_img.png" class="import_img"/>
        </div>
        <div class="p_i_import" v-else-if="importStatus === 1">
          <div class="progress_box">
            <span class="file_name"><i class="iconfont icon-wodedingdan"></i>{{ fileObj.name }}</span>
            <el-progress :percentage="fileObj.progress"></el-progress>
            <span class="close_btn">x</span>
          </div>
        </div>
        <div class="p_i_result" v-else-if="importStatus === 2 || communityList.length">
          <div class="r_header">
            <div class="r_b_search">
              <div class="s_input" :class="{'highlight': searchHightLight}">
                <el-input
                  v-model="communityKey" type="text" clearable
                  placeholder="输入小区名称" prefix-icon="iconfont icon-dingdanxiangqing-sousuo"
                  @focus="searchHightLight = true"  @focus.once="addKeyupEvent"
                  @blur="() => { searchHightLight = false; filterCommunityData() }"
                  ref="search-community"
                />
                <i class="search_text" @click="filterCommunityData">搜索</i>
              </div>
              <div class="fr" v-if="isImport">
                <p class="s_msg">
                  <b>结果： </b>成功 <em class="hl">{{ excelResult.successCount || 0 }}</em> ，
                  失败 {{ excelResult.failCount || 0 }}
                </p>
                <el-button type="text" class="s_button" @click="() => {importResultVisible = true}">查看详情</el-button>
              </div>
              <div class="fr" v-else-if="isOrderReput">
                <p class="s_msg">
                  <b>结果： </b>成功 <em class="hl">{{ excelResult.successCount || 0 }}</em> ，
                  失败 {{ excelResult.failCount || 0 }}
                </p>
                <el-button type="text" class="s_button" @click="() => {showReputDetail = true}">查看点位</el-button>
              </div>
            </div>
          </div>
          <div class="r_body">
            <div class="r_b_ul" :class="{empty: emptyCommunity}">
              <div class="r_b_list" v-for="item in communityList" :key="item.guid" v-show="item.visible">
                <el-checkbox
                  v-model="item.checked" @change="changeCommunityHandler(item)"
                  :indeterminate="!!item.allSelectDeviceCount && (item.allSelectDeviceCount !== item.allDeviceCount)"
                ></el-checkbox>
                <CommunityInfo :data.sync="item" :is-export="isImport"></CommunityInfo>
              </div>
            </div>
          </div>
          <div class="r_footer">
            <el-checkbox
              v-model="allSelect"
              :indeterminate="sumData.allWindow > sumData.window && sumData.window !== 0"
              @change="changeAllSelectHandler">
              <span class="dark r_checkbox_label">全选</span>
            </el-checkbox>
            <p class="r_f_price">
              <em class="hl">￥{{ discountMoney | tofixed2 }}</em>
              <span class="del">￥{{ sumData.price | tofixed2 }}</span>
            </p>
            <p class="r_f_msg">
              覆盖<em class="dark">{{ sumData.community }}</em>个小区、
              <em class="dark">{{ sumData.window }}</em>个屏
              <template v-if="sumData.man && sumData.man > -1">
                、<em class="dark">{{sumData.man}}</em>人
              </template>
            </p>
            <el-button class="f_import_button" @click="sendOrder">{{isImport?'导入投放':'立即投放'}}</el-button>
          </div>
        </div>
        <div class="p_i_import" v-else>
          <img v-if="isOrderReput" src="../../assets/order_reput.png" class="import_img" alt="订单复投">
          <img v-else src="../../assets/choose_condition.png" class="import_img"/>
        </div>
      </div>
    </template>
    <ImportResultDialog :visible.sync="importResultVisible" :import-type="importType" :uuid="uuid"></ImportResultDialog>
    <ReputDetail :visible.sync="showReputDetail" :orderCode="searchCondition.orderCode" :uuid="reputUuid"></ReputDetail>
    <OrderConfirm v-if="send" :options="orderOptions" @confirmBack="send = false"></OrderConfirm>
  </div>
</template>

<script>
import ImportCondition from './components/ImportCondition'
import ReputOrderCondition from './components/ReputOrderCondition'
import OrderFormPoint from './components/OrderFormPoint'
import CommunityInfo from './components/MyCommunityInfo'
import ImportResultDialog from './dialog/ImportResult'
import ReputDetail from './dialog/ReputDetail'
import OrderConfirm from '@/views/order/OrderConfirm'
import { getWifiPutByOrder } from '@/utils/api'

import searchLabelsMix from '@/utils/searchLabelsMix'
import searchPointMix from '@/utils/mixins/searchPointMix'

export default {
  name: 'PutOrderRealTimeContainer',
  mixins: [ searchLabelsMix, searchPointMix ],
  components: {
    ImportCondition,
    ReputOrderCondition,
    OrderFormPoint,
    CommunityInfo,
    ImportResultDialog,
    ReputDetail,
    OrderConfirm
  },
  filters: {
    tofixed2 (d) {
      return Number(d).toFixed(2)
    }
  },
  data () {
    return {
      importStatus: 0, // 0: 未导入， 1: 导入中 2: 导入完成
      communityList: [],
      searchHightLight: false,
      importResultVisible: false,
      showReputDetail: false, // 查看订单复投点位详情
      fileObj: {},
      searchCondition: {
        endDate: '',
        startDate: '',
        frequencyList: [],
        contentTime: ''
      },
      excelResult: {},
      uuid: '',
      sumData: {
        price: 0,
        community: 0,
        window: 0,
        man: 0
      },
      allSelect: false,
      discountList: [],
      orderOptions: {},
      send: false,
      communityKey: '',
      conditionData: null,
      selectedTimeSlots: {
        type: 0,
        typeName: '推荐时段',
        data: []
      },
      orderFormLabelList: {},
      reputUuid: '',
      repeatOrder: {} // 复投订单相关信息
    }
  },
  provide () {
    return {
      repeatOrder: this.repeatOrder
    }
  },
  computed: {
    isH5RealTime () {
      return this.$store.state.order.h5RealTime == 1;
    },
    wifiPutType () {
      return this.$store.state.order.conditionSearchTypeName
    },
    isImport () {
      return this.wifiPutType.indexOf('Import') > 0
    },
    importType () {
      return this.wifiPutType.replace('Import', '')
    },
    isOrderReput () {
      return this.wifiPutType.indexOf('Reput') > 0
    },
    timesAll () {
      return this.$store.state.order.timeRanges || []
    },
    listTimeStr () {
      return this.selectedTimeSlots.data.map(el => el.frequencyName + `(播放${el.playCount}次)`).join('、')
    },
    emptyCommunity () {
      return !this.communityList.some(item => {
        return item.visible
      })
    },
    discountMoney () {
      if (this.discountList.length === 0) return this.sumData.price
      let discount = 1
      this.discountList.forEach(item => {
        if (item.limit < this.sumData.price && discount > item.sale) discount = item.sale
      })
      let price = (discount * 100) * (this.sumData.price * 100) / 10000 - 0
      return price
    },
    apiObj () {
      if (this.importType === 'community') {
        return {
          uploadTemplate: '/boss/deviceSlot/v2/exportTemplate?type=1',
          importExcel: '/boss/deviceSlot/v2/importIntelligentNbhd'
        }
      } else {
        return {
          uploadTemplate: '/boss/deviceSlot/v2/exportTemplate?type=3',
          importExcel: '/boss/deviceSlot/v2/importIntelligentNbhd?type=3'
        }
      }
    }
  },
  watch: {
    send (v) {
      this.$emit('showConfirm', v)
    },
    wifiPutType () {
      this.resetPageInfo()
    },
    communityList: {
      deep: true,
      handler (nv) {
        this.sumData.price = 0
        this.sumData.community = 0
        this.sumData.window = 0
        this.sumData.allWindow = 0
        this.sumData.man = 0
        this.communityList.forEach(item => {
          if (item.checked) {
            this.sumData.price += item.allSelectSlotAmount
            this.sumData.community += 1
            this.sumData.window += item.allSelectDeviceCount
            this.sumData.man += item.audienceNumber
          }
          this.sumData.allWindow += item.allDeviceCount
        })
      }
    },
    'sumData.community' (nv) {
      if (!nv) {
        this.allSelect = false
      } else {
        this.allSelect = true
      }
    },
    communityKey (nv) {
      if (!nv) {
        this.filterCommunityData()
      }
    }
  },
  created () {
    this.getDiscountList()
  },
  beforeDestroy () {
    this.resetSearchStoreCommon()
  },
  methods: {
    // 条件搜索
    async conditionSearch (conditionData, notFromForm) {
      this.communityKey = ''
      this.conditionData = conditionData
      this.$store.commit('setStoreData', {
        key: 'mapSearchOptions',
        value: {
          ...conditionData,
          sex: conditionData.sex ? [conditionData.sex] : [],
          time: [conditionData.startDate, conditionData.endDate]
        }
      })

      let opt = {
        ...conditionData,
        addressCodes: conditionData.addressCodes,
        selectSlotRequest: {
          endDate: conditionData.endDate,
          startDate: conditionData.startDate
        }
      }
      let url = '/boss/deviceSlot/network/v2/getNetworkPutBySearch'
      opt.h5 = this.isH5RealTime

      delete opt.originPerson
      delete opt.targetFlowData
      delete opt.searchTimeRange

      let res = await this.fetch(url, opt)
      if (res && res.code === 0 && res.data) {
        this.setStoreSearchForConfirm(conditionData) // 设置store数据供确认订单页面使用
        let resData = res.data
        if (!resData.data || resData.data.length == 0) this.messageTip('暂无数据')
        this.communityList = this.handleListData(resData.data || [])
      }
    },
    async fillFrequencyNames (data) {
      if (!data || data.length == 0) return []
      let allTimeRanges = this.$store.state.bmap.allTimeRanges
      if (!allTimeRanges || allTimeRanges.length == 0) {
        await this.$store.dispatch('getTimeRanges')
        allTimeRanges = this.$store.state.bmap.allTimeRanges
      }
      let ids = allTimeRanges.map(el => el.guid)
      return data.map(el => {
        let idx = ids.indexOf(el.frequencyTime)
        if (idx > -1) el.frequencyName = allTimeRanges[idx].frequencyName
        else el.frequencyName = '未知'
        return el
      })
    },
    async importSearch ({ condition, result }) {
      this.searchCondition = condition
      this.conditionData = condition
      if (result.length <= 0) return false
      if (this.importType === 'device') {
        // 导入点位
        this.getDeviceSlotByExcel({ condition, result })
      } else {
        // 导入小区搜索
        const param = {
          ...condition,
          nbhdSearchMapResponse: result,
          selectSlotRequest: condition,
          h5: this.isH5RealTime
          // contentTime: condition.contentTime
        }
        let res = await this.fetch('/boss/deviceSlot/network/v2/getNetworkPutByNbhdExcel', param, 'POST')
        let data = res.data || {}
        this.excelResult.successCount = data.successCount || 0
        this.excelResult.failCount = data.failCount || 0
        let list = data.data || []
        if (list.length === 0) this.messageTip('暂无数据')
        this.communityList = this.handleListData(list)
        this.uuid = data.uuid
      }
    },
    // 导入点位搜索
    async getDeviceSlotByExcel ({ condition, result }) {
      if (result.length <= 0) return false
      let param = {
        nbhdSearchMapResponse: result,
        selectSlotRequest: condition,
        h5: this.isH5RealTime
        // contentTime: condition.contentTime
      }
      let res = await this.fetch('/boss/deviceSlot/network/v2/getNetworkPutByDeviceExcel', param, 'POST')
      let data = res.data || {}
      this.excelResult.successCount = data.successCount || 0
      this.excelResult.failCount = data.failCount || 0
      let list = data.data || []
      if (list.length === 0) this.messageTip('暂无数据')
      this.communityList = this.handleListData(list)
      this.uuid = data.uuid
    },
    async searchWifiByOrder (reputParam) {
      console.log('实时广告订单复投：', reputParam)
      this.searchCondition = reputParam
      this.conditionData = reputParam
      this.$store.commit('setStoreData', {
        key: 'mapSearchOptions',
        value: {
          orderCode: reputParam.orderCode,
          time: [reputParam.selectSlotRequest.startDate, reputParam.selectSlotRequest.endDate]
        }
      })
      let res = await getWifiPutByOrder({ ...reputParam, h5: this.isH5RealTime })
      if (res && res.code === 0 && res.data) {
        let resData = res.data

        Object.assign(this.repeatOrder, resData.repeatOrder || {})

        this.reputUuid = resData.uuid || ''
        this.excelResult.successCount = resData.successCount || 0
        this.excelResult.failCount = resData.failCount || 0
        if (!resData.data || resData.data.length == 0) {
          this.communityList = []
          return this.messageTip('暂无数据')
        }
        this.communityList = this.handleListData(resData.data || [])
      }
    },
    handleListData (arr) {
      return arr.map(item => {
        item.checked = item.tnSelectSlotAmount > 0
        item.visible = true
        item.allSelectDeviceCount = item.tnSelectDeviceCount
        item.allSelectSlotAmount =  item.tnSelectSlotAmount
        item.allDeviceCount = item.tnAllDeviceCount
        return item
      })
    },
    addKeyupEvent () {
      this.$refs['search-community'].$el.addEventListener('keyup', e => {
        if (e.code === 'Enter') {
          this.filterCommunityData()
        }
      })
    },
    // 立即/导入投放
    sendOrder () {
      let isExport = this.isImport
      let chooseCmS = this.communityList.filter(el => el.checked)
      if (chooseCmS.length === 0) return this.messageTip('请勾选小区')
      if (isExport) {
        this.handleConfirmData(chooseCmS)
      } else {
        this.$store.commit('setSearchDetail', this.communityList)
      }
      this.orderOptions = {
        type: isExport ? 'excelImport' : 'condition',
        data: chooseCmS,
        isExport,
        isWifi: true,
        conditionData: this.conditionData
      }
      this.send = true
    },
    handleConfirmData (chooseCmS) { // 处理excel上传导入确认订单页面需要数据
      this.$store.commit('setStoreData', {
        key: ['mapSearchOptions', 'contentTime'],
        value: this.searchCondition.contentTime
      })
      let { startDate, endDate } = this.searchCondition
      this.$store.commit('setStoreData', { key: ['mapSearchOptions', 'time'], value: [startDate, endDate] })
      this.$store.commit('setSearchDetail', this.communityList)
    },
    uploadProgress ({ name, progress }) {
      this.fileObj = { name, progress }
    },
    filterCommunityData () {
      this.communityList.forEach(item => {
        if (item.name.indexOf(this.communityKey.trim()) > -1) {
          item.visible = true
        } else {
          item.visible = false
        }
      })
    },
    changeCommunityHandler (item) {
      if (item.checked) {
        item.allSelectSlotAmount = item.tnAllSlotAmount
        item.allSelectDeviceCount = item.allDeviceCount
        item.tnSelectDeviceCount = item.tnAllDeviceCount
        item.tnSelectSlotAmount = item.tnAllSlotAmount
        item.twSelectDeviceCount = item.twAllDeviceCount
        item.twSelectSlotAmount = item.twAllSlotAmount
      } else {
        item.allSelectSlotAmount = 0
        item.allSelectDeviceCount = 0
        item.tnSelectDeviceCount = 0
        item.tnSelectSlotAmount = 0
        item.twSelectDeviceCount = 0
        item.twSelectSlotAmount = 0
        item.allSelectSlotAmount = 0
      }
    },
    changeAllSelectHandler (status) {
      this.communityList.forEach(item => {
        item.checked = status
        item.allSelectSlotAmount = status ? item.tnAllSlotAmount : 0
        item.allSelectDeviceCount = status ? item.allDeviceCount : 0
        item.tnSelectDeviceCount = status ? item.tnAllDeviceCount : 0
        item.tnSelectSlotAmount = status ? item.tnAllSlotAmount : 0
        item.twSelectDeviceCount = status ? item.twAllDeviceCount : 0
        item.twSelectSlotAmount = status ? item.twAllSlotAmount : 0
        item.selectDeviceCount = status ? item.allDeviceCount : 0
      })
    },
    async getDiscountList () {
      let response = await this.fetch('/boss/common/config/v2/getDiscountActivity', '', 'get')
      this.discountList = response.data || []
    },
    resetPageInfo () {
      this.communityList = []
      this.selectedTimeSlots.data = []
      this.communityKey = ''
      this.$store.commit('setStoreData', { key: 'recommendTimeSlotData', value: [] })
    }
  }
}
</script>

<style lang="scss" scoped>
.put_import_container {
  position: relative;
  height: calc(100% - 50px);
  margin: 0 2px;
  &.full_page {
    height: 100%;
  }
}
.p_i_left {
  position: absolute;
  z-index: 0;
  left: 0;
  top: 0;
  bottom: 0;
  width: 360px;
  box-shadow: -1px 0 0 0 #e9e9e9 inset;
  ::v-deep .el-form-item__label {
    font-weight: 700;
  }
}
.p_i_right {
  position: relative;
  height: 100%;
  margin-left: 360px;
  overflow-y: auto;
}
.p_i_result {
  height: 100%;
  min-width: 635px;
}
.import_img {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 300px;
  height: 210px;
  margin-top: -105px;
  margin-left: -150px;
  cursor: pointer;
}
.r_b_search {
  position: relative;
  padding-right: 20px;
  border-bottom: 1px solid #e9e9e9;
  .s_input {
    position: relative;
    z-index: 1;
    background: #fff;
    display: inline-block;
    width: 220px;
    border-right: 1px solid #E9E9E9;
    transition: all .8s;
    &.no-time {
      width: 300px;
      &.highlight {
        width: 380px;
        box-shadow: 2px 0px 10px 0px rgba(255, 57, 115, 0.2), -1px 0px 0px 0px rgba(233, 233, 233, 1), 0px 1px 0px 0px rgba(255, 57, 115, 1);
        .search_text {
          opacity: 1;
        }
      }
    }
    &.highlight {
      width: 300px;
      box-shadow: 2px 0px 10px 0px rgba(255, 57, 115, 0.2), -1px 0px 0px 0px rgba(233, 233, 233, 1), 0px 1px 0px 0px rgba(255, 57, 115, 1);
      .search_text {
        opacity: 1;
      }
    }
    .search_text {
      display: inline-block;
      opacity: 0;
      width: 24px;
      font-size: 12px;
      vertical-align: middle;
      cursor: pointer;
      color: #999;
    }
    .el-input {
      display: inline-block;
      width: calc(100% - 34px);
    }
    ::v-deep .el-input__inner {
      font-size: 12px;
      padding-left: 40px;
      border: none;
    }
    ::v-deep .el-input__prefix {
      left: 18px;
    }
    ::v-deep .iconfont {
      font-size: 16px;
    }
    ::v-deep .el-input__suffix-inner {
      position: relative;
      top: 1px;
    }
  }
  .s_msg {
    display: inline-block;
    padding-right: 20px;
    font-size: 14px;
    line-height: 20px;
    border-right: 1px solid #E9E9E9;
    .hl {
      color: #3083F2;
      font-style: normal;
    }
  }
  .s_button {
    margin-left: 20px;
    color: #878A92;
    font-size: 14px;
  }
}
.r_b_ul.empty::after {
  display: block;
  margin: 10px;
  padding: 52px;
  content: '暂无结果，换个名称重新试试吧~';
  color: #999;
  font-size: 12px;
  line-height: 17px;
  text-align: center;
  background-color: #F5F5F5;
}
.r_b_list {
  padding-left: 20px;
  margin-left: 0;
  width: 100%;
  box-shadow: 0 -1px 0 0 #e9e9e9 inset;
  ::v-deep .el-checkbox__label {
    vertical-align: middle;
    width: calc(100% - 13px);
  }
  &:hover {
    background: #E9E9E9;
    ::v-deep .label_item {
      background: #FFF;
    }
  }
}
.community_outer {
  vertical-align: middle;
  margin-left: 12px;
  width: calc(100% - 26px);
}
.r_body {
  height: calc(100% - 100px);
  overflow-y: auto;
  overflow-x: hidden;
}
.r_footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: grid;
  grid-template-columns: 84px auto 160px;
  grid-template-rows: 32px 28px;
  grid-auto-flow: column;
  align-items: center;
  background-color: #fff;
  box-shadow: 0 -1px 0 0 #E9E9E9;
  z-index: 1;
  .el-checkbox {
    grid-row: 1 / 3;
    margin-left: 20px;
  }
  .r_checkbox_label {
    font-size: 14px;
  }
  .f_import_button {
    grid-row: 1 / 3;
    color: #fff;
    width: 120px;
    height: 40px;
    margin-left: 20px;
    font-size: 14px;
    background: linear-gradient(315deg, rgba(255, 132, 109, 1) 0%, rgba(255, 57, 115, 1) 100%);
    border-radius: 4px;
    border: none;
  }
  .r_f_price {
    padding-top: 7px;
    line-height: 25px;
    font-family: Akrobat;
    .hl {
      font-size: 20px;
      font-weight: 800;
    }
    .del {
      margin-left: 10px;
      color: #666666;
      font-size: 14px;
      line-height: 17px;
      text-decoration: line-through;
    }
  }
  .r_f_msg {
    padding-bottom: 6px;
    color: #999;
    font-size: 14px;
    line-height: 20px;
  }
  .hl {
    color: #FF3973;
    font-size: 16px;
    line-height: 20px;
    font-weight: bold;
  }
  .dark {
    color: #282729;
    font-size: 14px;
    line-height: 20px;
  }
}
em {
  font-style: normal;
}
.progress_box {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 400px;
  height: 64px;
  margin-left: -200px;
  margin-top: -32px;
  padding: 20px;
  border: 1px solid #D4D4D4;
  border-radius: 4px;
  .file_name {
    color: #666;
    font-size: 12px;
    line-height: 17px;
    .iconfont {
      margin-right: 6px;
      vertical-align: middle;
    }
  }
  ::v-deep .el-progress-bar {
    padding-right: 0;
    margin-right: 0;
  }
  ::v-deep .el-progress__text {
    position: absolute;
    right: 0;
    top: -100%;
    color: #FF3973;
  }
  ::v-deep .el-progress-bar__inner {
    background-color: #FF3973;
  }
  ::v-deep .el-progress-bar__outer {
    height: 3px !important;
  }
  .close_btn {
    position: absolute;
    right: -34px;
    top: 50%;
    width: 24px;
    height: 24px;
    margin-top: -12px;
    color: #282729;
    text-align: center;
    line-height: 24px;
    border-radius: 50%;
    border: 1px solid #D4D4D4;
    cursor: pointer;
  }
}
</style>
